import common from './common/link'

export default {
  "name": "Link 4",
  "slug": "link-4",
  "level": 4,
  "assets": {
    "logo": "/themes/link/link-logo.svg",
    "favicon": "/themes/link/link-fav.png"
  },
  "hasRoleSwitch": true,
  "login": {
    "type": "guardTeacherOnly"
  },
  "dbok": [
    {
      "bookId": "5f18036f7228e00012e5f896",
    },
    {
      "bookId": "5f310304833f2000193466ee",
    },
    {
      "bookId": "5f1803e87228e00012e5fbdf",
    },
    {
      "bookId": "5f3111ca833f20001934696c",
    },
    {
      "bookId": "5f34defa833f200019348ed6",
    }
  ],
  ...common
}
